export default __webpack_public_path__ + "static/media/create-nested-span.8224b4eb.gif";